import { getPausedStates } from "../api/multi-call";
import type { ChainId } from "../api/vault-config";
import { getVaultByKey } from "../vaults";
import type { VaultKey } from "../vaults/config";

type VaultStatusParams = {
  vaultKey: VaultKey;
  chainId: ChainId;
};

const getVaultStatus = async ({ vaultKey, chainId }: VaultStatusParams) => {
  const vault = await getVaultByKey(vaultKey);
  if (!vault) {
    throw new Error(`Vault not found: ${vaultKey}`);
  }

  const tellerAddress = vault.contracts.teller;
  const accountantAddress = vault.contracts.accountant;

  const [tellerStatus, accountantStatus] = await getPausedStates({
    accountantAddress,
    tellerAddress,
    chainId,
  });

  if (tellerStatus.status === "failure") {
    throw new Error(tellerStatus.error.message);
  }

  if (accountantStatus.status === "failure") {
    throw new Error(accountantStatus.error.message);
  }

  if (tellerStatus.result === true || accountantStatus.result[7] === true) {
    return {
      isPaused: true,
    };
  }

  return {
    isPaused: false,
  };
};

export { getVaultStatus };
